<template>
  <v-dialog v-model="dialog" persistent max-width="800">
    <v-card>
      <v-card-title
        class="modal-header elevation-10"
      >
        <v-row>
          <v-col>
            <slot name="title">Relatório SGF</slot>
          </v-col>
          <v-col class="text-right">
            <v-icon @click="$emit('onCloseReport')" color="white">mdi-window-close</v-icon>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row class="text-center">
          <v-col sm="2">
            <img
              src="@/assets/img/sebrae-logo.png"
              width="100px"
            >
          </v-col>
          <v-col style="background-color:#ccc">
            <h1>RELATÓRIO DE ATIVIDADES DE CONSULTORIA DE PROJETO E EDUCACIONAL</h1>
          </v-col>
        </v-row>

        <v-row>
          <v-col
            md="6"
            offset-md="6"
          ><b>Nº do Relatório:</b> {{ report.numero }} de {{ report.total }}</v-col>
        </v-row>
        <v-divider></v-divider>

        <v-row>
          <v-col><b>Código da Contratação:</b> {{ report.codigoContratacao }}</v-col>
        </v-row>
        <v-divider></v-divider>

        <v-row>
          <v-col><b>Período de realização:</b> {{ report.periodoRealizacao }}</v-col>
        </v-row>
        <v-divider></v-divider>

        <v-row class="text-center">
          <v-col style="background-color:#ccc">
            <h1>DADOS DA EMPRESA</h1>
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row>
          <v-col v-if="report.usuario"><b>Razão Social:</b> {{ report.usuario.razaoSocial }}</v-col>
        </v-row>
        <v-row>
          <v-col v-if="report.usuario"><b>Profissional indicado prestador do serviço:</b> {{ report.usuario.nome }}</v-col>
        </v-row>
        <v-row>
          <v-col v-if="report.usuario"><b>Telefone Celular:</b> {{ report.usuario.telefone }}</v-col>
        </v-row>
        <v-row>
          <v-col v-if="report.usuario"><b>E-mail:</b> {{ report.usuario.email }}</v-col>
        </v-row>
        <v-divider></v-divider>

        <v-row class="text-center">
          <v-col style="background-color:#ccc">
            <h1>EXECUÇÃO DO TRABALHO</h1>
          </v-col>
        </v-row>
        <v-divider></v-divider>

        <v-row>
          <v-col><b>Horas executadas comprovadas neste relatório:</b> {{ report.horas }} h</v-col>
          <v-col><b>Horas a executar (se houver):</b> </v-col>
        </v-row>

        <v-row class="text-center">
          <v-col><b>ATIVIDADE</b></v-col>
          <v-col><b>HORAS REALIZADAS</b></v-col>
        </v-row>

        <v-row v-for="relatorio in report.relatorioPagamento" :key="relatorio.relatorioPagamentoId">
          <v-col v-if="relatorio.relatorio.encontro.solucoes && !relatorio.relatorio.encontro.solucoes[0].municipioSolucao.naoComputaHoras">{{ relatorio.relatorio.encontro.solucoes[0].municipioSolucao.nome }} - {{ relatorio.relatorio.municipio.nome }}</v-col>
          <v-col v-if="relatorio.relatorio.encontro.solucoes && !relatorio.relatorio.encontro.solucoes[0].municipioSolucao.naoComputaHoras" align="center">{{ relatorio.relatorio.horasTarefas }} h</v-col>
        </v-row>

        <v-row v-for="relatorioAdministrativoPagamento in report.relatorioAdministrativoPagamento" :key="relatorioAdministrativoPagamento.relatorioAdministrativoId + 'administrativo'">
          <v-col>{{ relatorioAdministrativoPagamento.relatorioAdministrativo.titulo }}</v-col>
          <v-col align="center">{{ relatorioAdministrativoPagamento.horas }} h</v-col>
        </v-row>

        <v-row class="text-center">
          <v-col><b>TOTAL</b></v-col>
          <v-col><b>{{ report.horas }} h</b></v-col>
        </v-row>
        <v-divider></v-divider>

        <v-row class="text-center">
          <v-col style="background-color:#ccc">
            <h1>DESCRIÇÃO DAS ATIVIDADES REALIZADAS</h1>
          </v-col>
        </v-row>
        <v-divider></v-divider>

        <v-row v-for="relatorio in report.relatorioPagamento" :key="relatorio.relatorioPagamentoId + '1'">
          <v-col v-if="relatorio.relatorio.encontro.solucoes && !relatorio.relatorio.encontro.solucoes[0].municipioSolucao.naoComputaHoras">{{ relatorio.relatorio.encontro.solucoes[0].municipioSolucao.nome }} - {{ relatorio.relatorio.municipio.nome }} - {{ relatorio.relatorio.tarefasString }}</v-col>
          <v-col v-if="relatorio.relatorio.encontro.solucoes && !relatorio.relatorio.encontro.solucoes[0].municipioSolucao.naoComputaHoras" align="center">{{ relatorio.relatorio.horasTarefas }} h</v-col>
        </v-row>

        <v-row v-for="relatorioAdministrativoPagamento in report.relatorioAdministrativoPagamento" :key="relatorioAdministrativoPagamento.relatorioAdministrativoId + 'administrativo1'">
          <v-col>{{ relatorioAdministrativoPagamento.relatorioAdministrativo.descricao }}</v-col>
          <v-col align="center">{{ relatorioAdministrativoPagamento.horas }} h</v-col>
        </v-row>
        <v-divider></v-divider>

        <v-row>
          <v-col><b>Data: ______/______/__________.</b></v-col>
        </v-row>
        <v-divider></v-divider>

        <v-row class="text-center" v-if="report.usuario">
          <v-col v-if="!report.usuario.nomeArquivoAssinatura">_______________________________</v-col>
          <v-col v-if="report.usuario.nomeArquivoAssinatura">
            <img :src="'data:image/' + report.usuario.extensaoArquivoAssinatura + ';base64,' + report.usuario.arrayArquivoAssinatura" height="70px">
          </v-col>
        </v-row>
        <v-row class="text-center">
          <v-col><b>Assinatura do Consultor</b></v-col>
        </v-row>
        <v-row class="text-center">
          <v-col v-if="report.usuario"><b>Nome:</b> {{ report.usuario.nome }}</v-col>
        </v-row>
        <v-row class="text-center">
          <v-col v-if="report.usuario"><b>Empresa:</b> {{ report.usuario.razaoSocial }}</v-col>
        </v-row>

      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="error" outlined text @click="$emit('onCloseReport')">Fechar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { paymentReportManagementAPI } from '@/modules/payment-management'

export default {
  name: 'AppModalReportSGF',
  props: {
    dialog: { type: Boolean, default: false },
    payload: { type: Object, required: true }
  },
  data () {
    return {
      report: {}
    }
  },
  methods: {
    ...mapActions([
      'setLoading'
    ]),
    get () {
      this.setLoading(true)
      paymentReportManagementAPI.get(this.payload.relatorioGestaoPagamentoId)
        .then(resp => {
          this.report = resp.data
          this.setLoading(false)
        })
        .catch(resp => {
          this.setLoading(false)
          this.$notification.error('Erro ao obter processo de pagamento')
        })
    }
  },
  computed: {
    ...mapGetters([
      'isAdmin'
    ])
  },
  watch: {
    dialog (value) {
      if (value) {
        this.get()
      }
    }
  }
}
</script>

<style lang="scss">@import './style.scss';</style>
